module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7WUfQ"))).then(() => parcelRequire('37nVf'));